import API from '@/lib/API.js'
import comun from './comun.js'
const EstadoCivil = {
    namespaced: true,
    state: {
        Lista: [],
        Seleccionado: undefined
    },
    mutations: {
        init(state) {
            state.Seleccionado = undefined;
        },
        set(state, payload) {
            state.Lista = payload;
        },
    },
    actions: {
        async set({
            commit,
            getters
        }) {
            let entidades = getters.getEstado_Civil();
            if (entidades.length === 0) {
                commit("comun/cargando")
                let data = await API.Estado_Civil.traerTodos();
                commit("set", data)
                commit("comun/fincarga")
            }
        },
    },
    getters: {
        getEstado_Civil: state => () => {
            return state.Lista;
        },
    },
    modules: {
        comun,
    }

}
export default EstadoCivil;